import { useRef, useEffect, useState } from 'react';
export function useElementWidth(enabled = true) {
  const ref = useRef(null);
  const [width, setWidth] = useState(null);
  useEffect(() => {
    if (!enabled) return;
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver(entries => {
      setWidth(entries[0].contentRect.width);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [enabled]);
  return {
    ref,
    width
  };
}